module.exports = __webpack_public_path__ + "img/1.17832fa2.jpg";